import type { DialogConfig } from '@svenskaspelab/nova-foundation/nextjs/dialog';
import { marketplaceBalanceMw } from '@svenskaspelab/nova-payment-sport';
import { createElement } from 'react';

import { getFormattedCurrency } from '../../lib/entry.browser.js';

/**
 * Creates a payment confirmation middleware with the provided showDialog function.
 *
 * @param showDialog Dialog function to show confirmation dialog
 * @returns Payment confirmation middleware
 */
export function marketplaceBalance(
  showDialog: (props: DialogConfig, meta?: string[]) => Promise<void>
): ReturnType<typeof marketplaceBalanceMw> {
  return marketplaceBalanceMw(
    (paymentContext) =>
      new Promise((resolve, reject) => {
        const { title, insufficientWallets } = paymentContext ?? {};

        const messages: string[] = [];
        if (insufficientWallets) {
          for (const wallet of insufficientWallets) {
            messages.push(
              `Att betala för på ${wallet.name}: ${getFormattedCurrency(wallet.balance, { shouldUseDecimals: true })}, pris: ${getFormattedCurrency(wallet.price)}.`
            );
          }
        }
        showDialog({
          title: title || 'Ni har inte tillräckligt med pengar för att betala',
          description: messages.map((msg, index) =>
            // eslint-disable-next-line react/no-array-index-key
            createElement('p', { key: index, className: 'text-center lg:text-left' }, msg)
          ),
          buttons: {
            primary: {
              label: 'Okej',
              action: () => {
                resolve();
              },
            },
          },
        }).catch(() => {
          // If the dialog is closed in another way (ESC, click outside, etc.)
          reject(new Error('Abort payment flow clicked, not enough balance.'));
        });
      })
  );
}
